import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Loading and empty overlays for the EMD charts.
 *
 * Empty matters here because the badges can cut every row out, and a chart that
 * responds by drawing bare axes reads as broken rather than as filtered.
 */
@Component({
    selector: 'emd-chart-states',
    template: `
    <div class="emd-state emd-state--loading" *ngIf="loading">
      <div class="emd-skeleton" [class.emd-skeleton--map]="variant === 'map'">
        <div class="emd-skeleton-bar" *ngFor="let bar of skeletonBars" [style.height.%]="bar"></div>
      </div>
      <span class="emd-state-text">Loading…</span>
    </div>

    <div class="emd-state emd-state--empty" *ngIf="!loading && empty">
      <svg class="emd-state-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M3 5h18M6 10h12M9 15h6M11 20h2"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
      <span class="emd-state-text">{{ message }}</span>
      <button type="button" class="emd-state-action" *ngIf="showClear" (click)="clear.emit()">
        Clear filters
      </button>
    </div>
  `,
    styleUrls: ['./emd-chart-states.component.scss'],
    standalone: false
})
export class EmdChartStatesComponent {
  @Input() loading = false;
  @Input() empty = false;
  @Input() message = 'No data for the selected filters';
  @Input() showClear = false;
  @Input() variant: 'bars' | 'map' = 'bars';

  @Output() clear = new EventEmitter<void>();

  readonly skeletonBars = [45, 70, 35, 85, 55, 75, 40];
}
